export default __webpack_public_path__ + "static/media/StatusRunning.c200f155.png";